import { Injectable } from "@angular/core";
import { HttpDataService } from "../../../services/shared";

@Injectable()
export class ReportService {

    constructor(private httpData: HttpDataService) { }
}



// WEBPACK FOOTER //
// ./src/app/modules/userHome/reports/reports.service.ts